import { render } from "./LeadExpire.vue?vue&type=template&id=5c23e7ba&scoped=true"
import script from "./LeadExpire.vue?vue&type=script&lang=js"
export * from "./LeadExpire.vue?vue&type=script&lang=js"

import "./LeadExpire.vue?vue&type=style&index=0&id=5c23e7ba&scoped=true&lang=css"

import exportComponent from "/Users/rppig42/Code/dbkf/uworker-mobile/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.2.21_vue@3.2.21_webpack@4.47.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c23e7ba"]])

export default __exports__